<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a href="javascript:" class="ui_close" @click="btnClose"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis maintit">
                    <i>{{ getTitle }}</i>
                </dt>
                <dd>
                    <div class="view_cont">
                        <div class="view_info">
                            <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                                {{ detail.PRD_CATEGORY_NM1 }} 
                                <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }} 
                                <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                            </div>
                        </div>
                        <dl class="view_subject">
                            <dt class="subject">
                                <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                                <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                                {{ detail.KNOWLEDGE_TITLE | refTitle | decodeXSS }}
                            </dt>
                            <dd class="desc">
                                <span class="desc_Regist">
                                    <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                                    {{ detail.REG_USER }} ({{ detail.REG_DT }})
                                </span>
                                <span class="desc_modify">
                                    <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                                    {{ detail.MODF_USER }} ({{ detail.MODF_DT }})
                                </span>
                            </dd>
                        </dl>

                        <!-- tab -->
                        <div class="view_desc">
                            <!-- 200420수정 S -->
                            <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                            <table v-if="isSCMS" class="data_table_ty2 mb-20">
                                <colgroup>
                                    <col width="20%">
                                    <col width="30%">
                                    <col width="20%">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                                        <td colspan="3">
                                            <ul class="in_dotlist" v-if="symptomList.length === 0">
                                                <li>&nbsp;</li>
                                            </ul>
                                            <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                                <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                                        <td>
                                            <ul class="in_dotlist">
                                                <li v-if="typeof(detail.MANUFACTURE_S_DT) !== 'undefined'">
                                                    {{ (detail.MANUFACTURE_S_DT + '01') | dateFormat('MMM.YYYY') }} ~ {{ (detail.MANUFACTURE_E_DT + '01') | dateFormat('MMM.YYYY') }}
                                                </li>
                                            </ul>
                                        </td>
                                        <th class="text_left">{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</th>
                                        <td>
                                            <ul class="in_dotlist" v-if="serialList.length === 0">
                                                <li>&nbsp;</li>
                                            </ul>
                                            <ul class="in_dotlist" v-else v-for="serial in serialList">
                                                <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E}}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                                        <td>{{ getGuideTypeName }}</td>
                                        <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                                        <td>{{ getDefectTypeName }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- //200420수정 E -->


                            <div class="tab_wrap tab_wrap_version">
                                <ul class="tab_menu_02 tab_menus tab_menus_version">
                                    <li class="on" @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                                    <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                                    <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                                    <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                                </ul>
                                <div class="tab_contents">
                                    <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                                    <div class="tab_cont">
                                        <toast-grid
                                            v-if="reloadModel"
                                            :gridId="modelGridId"
                                            :ref="modelGridId"
                                            :data="modelList"
                                            :columns="modelColumns"
                                            :options="options"
                                            :pageOptions="pageOptions"
                                            :isTotalCount="true"
                                        />
                                    </div>
                                    <div class="tab_cont">
                                        <toast-grid
                                            v-if="reloadParts"
                                            :gridId="partsGridId"
                                            :ref="partsGridId"
                                            :data="partsList"
                                            :columns="partsColumns"
                                            :options="options"
                                            :pageOptions="pageOptions"
                                            :isTotalCount="true"
                                        />
                                    </div>
                                    <div class="tab_cont">
                                        <!-- Version Tab -->
                                        <table class="data_table">
                                            <colgroup>
                                                <col width="15%">
                                                <col width="15%" class="pc_only">
                                                <col width="25%" class="pc_only">
                                                <col width="*">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                                    <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                                    <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                                    <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                                </tr>
                                            </thead>
                                            <tbody class="text_center">
                                                <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                                    <td>Ver.{{ version.VERSION_NO }}</td>
                                                    <td class="pc_only">{{ version.MODF_DT }}</td>
                                                    <td class="pc_only">{{ version.MODF_USER }}</td>
                                                    <td class="text_left">
                                                        {{ version.MODF_REASON | decodeXSS }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <!-- Attachment -->
                            <innorix-download
                                v-if="attach.length > 0"
                                :uploadId="uploadId"
                                :serviceType="serviceType"
                                :attachList="attach"
                                :seq="getKnowledgeId"
                            />
                            <!-- //Attachment -->
                            <dl class="attachment_link attachment_link_version" v-if="attach.length > 0">
                                <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                                <dd>
                                    <ul>
                                        <li v-for="file in attach" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                            <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                                <span class="ico_attach"></span> {{ file.FILE_NM }}
                                            </a>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_wrap topLine">
                        <div class="btn_right pc_only">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.CLOSE')" @click="btnClose">{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import ToastGrid                            from '~c/ToastGrid';
import CrossEditorViewer                    from '~c/CrossEditorViewer';
import InnorixDownload                      from '~c/InnorixDownload';
import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

const SCMS_CONTENTS_CD = [
    'SB',   // Service Bulletin
    'RT',   // Repair Tip
];

export default {
    name: 'KnowledgeVersionDetailPopup',
    props : {
        KNOWLEDGE_ID:       { required: true },
        VERSION_NO:         { required: true },
        title:              { },
        isRequestSharing:   { default: false },
        rtnFunc:            { type: Function }
    },
    data() {
        return {
            isLoading : true,
            pageTitle: SDLUtil.getMsgProp('FIELD.KNOWLEDGE.VERHISTORY'),
            window: { width: 0, height: 0 },

            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            detail: {},
            attach: [],
            versionList: [],
            isPrevious: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,

            isShare: false,
            isAllowSharing: false,
            distTarget: '',

            reloadModel: false,
            reloadParts: false,

            editorId: 'editorVer_' + String(this.knowledgeId),

            modelGridId: 'mdlVerGrid_' + String(this.knowledgeId),
            modelColumns: [
                /* 2020.06.26 Subsidiary 컬럼 삭제 */
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', resizable: true, sortable: true,
                            filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'NMMODEL', align: 'center', resizable: true, sortable: true },
                { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                { header: 'CDGBM', name: 'CDGBM', hidden: true },
            ],

            partsGridId: 'ptsVerGrid_' + String(this.knowledgeId),
            partsColumns: [
                /* 2020.04.06 Parts Name 컬럼 삭제 */
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.CODE'), name: 'PARTS_CODE', align: 'center', resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.TYPE'), name: 'PARTS_TYPE', align: 'center', resizable: true, sortable: true }
            ],

            options: {
                scrollY: true,
                minBodyHeight: 80,
                bodyHeight: 265
            },
            pageOptions: {
                useClient: true,
                perPage: 20
            },

            uploadId: 'downloadVer_' + String(this.knowledgeId),
            serviceType: 'common'
        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
        }),
        getKnowledgeId() {
            return this.KNOWLEDGE_ID;
        },
        getVersionNo() {
            return this.VERSION_NO;
        },
        getTitle() {
            return this.title || this.pageTitle;
        },
        getEditorId() {
            return this.editorId;
        },
        getBoardCreationYN() {
            return store.getters.getParams.creationYn || 'N';
        },
        getDefectTypeName() {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'toast-grid'        : ToastGrid,
        'cross-editor'      : CrossEditorViewer,
        'innorix-download'  : InnorixDownload
    },
    methods: {
        // initiation
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(
                    `${SDLUtil.API_URL}/basis/knowledge/findKnowledgeDetailHistory.skp`,
                    qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, VERSION_NO: this.getVersionNo }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.go(-1);
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },

        // 즐겨찾기 버튼 클릭
        clickFavorite(e) {
            Vue.$log.info('▶ KnowledgeDetailPopup.vue click favorite => ', this.isFavorite);
            let url = '', fvParams = { workCd: MenuUtil.getScrapWorkCode(), workCdSeq: this.getKnowledgeId };
            if( this.isFavorite ) {
                url = `${SDLUtil.API_URL}/basis/common/scrap/deleteScrap.skp`;
                this.isFavorite = false;
            } else {
                url = `${SDLUtil.API_URL}/basis/common/scrap/scrap.skp`;
                this.isFavorite = true;
            }

            return  axios.post( url, qs.stringify(fvParams), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } } )
                    .then(res => {
                        let msg = "";
                        if( this.isFavorite ) {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.ADDFAVORITE');
                        } else {
                            msg = SDLUtil.getMsgProp('MESSAGE.GLOBAL.REMOVEFAVORITE');
                        }
                        // Notification
                        Vue.toasted.show( msg, { theme: "toasted-primary", position: "top-center", duration : 3000 } );
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                    });
        },
        changeTab(e) {
            var tabIndex = $('.tab_menus_version > li > a').index(e.target);
            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap_version .tab_cont').hide();
            } else {
                $('.tab_wrap_version li').removeClass('on');
                $('.tab_wrap_version .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap_version .tab_cont').eq(tabIndex).show();
                
                if(tabIndex == 1) {
                    this.modelList = this.modelList;
                    this.reloadModel = true;

                } else if(tabIndex == 2) {
                    this.partsList = this.partsList;
                    this.reloadParts = true;

                } else {
                    this.reloadModel = false;
                    this.reloadParts = false;
                }
            }

            EventBus.$emit('grid-refresh');
        },
        btnAuth() {
            let isAuth = false;
            if(
                SDLUtil.isNull(this.detail.CTTID) &&
                this.userRoles.find(
                    r => r === `${constants.SYSTEM_ADMIN}`
                      || r === `${constants.GBM_ADMIN}`
                      || r === `${constants.RHQ_ADMIN}`
                      || r === `${constants.SUB_ADMIN}`
                      /*
                        /basis/knowledge/symptom/Detail.jsp line 541
                        Environment admin 권한에 대해서도 수정 할 수 있는 권한을 부여하자
                        ( 전제조건: Environment 환경 컨텐츠 국한되어야 하는데... ) SEA 의 경우 ROLE 2200 은 환경컨텐츠가 아님.
                      */
                      || ( r === `${constants.ENV_ADMIN}` && this.userCorpCd !== 'C310' )
                )
            ) {
                isAuth = true;
            }

            return isAuth;
        },
        btnExpire() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.confirm({
                title: "TITLE.WARNING.TITLE",
                msg: 'MESSAGE.DATA.EXPIRE.CONFIRM',
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/myKnowledge/register/expire.skp`,
                                qs.stringify({ KNOWLEDGE_ID: this.getKnowledgeId, boardTypeRoot: this.userCorpCd }),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'FIELD.GLOBAL.PROGRESS.COMPLETE',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            this.goList();
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
            SDLUtil.showLoadingBar(false);
        },

        btnClose() {
            if(typeof this.rtnFunc === 'function') {
                this.rtnFunc();
            }

            this.$emit('close');
        },

        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },

        toggleLink(e) {
            $('.attachment_link_version > dd').toggle();
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.initLoad().then(res => {
            Vue.$log.info("▶ KnowledgeVersionDetailPopup.vue Response => ", res);
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.modelList = res.modelList.rowData;
            this.modelColumnName = res.modelList.columnName;
            this.partsList = res.partsList.rowData;
            this.detail = res.detail.rowData[0];
            this.attach = res.attach.rowData;
            this.versionList = res.version.rowData;

            // Knowledge Allow sharing 이 체크되어 있는 상태에서 법인 배포, Request Sharing 이 되지 않은 건만 버튼 활성
            this.isAllowSharing = StringUtil.strToBool(this.detail.ALLOW_SHARE);
            if(this.isRequestSharing && this.isAllowSharing) {
                let distTarget = this.detail.DIST_TARGET,
                    shareId = SDLUtil.nvl(this.detail.SHARE_ID, '');

                if(distTarget === 'S' && SDLUtil.isNull(shareId)) {
                    this.isShare = true;

                } else {
                    this.isShare = false;
                };

            } else {
                this.isShare = false;
            };

            // 즐겨찾기 확인
            try{
                if(this.detail['FAVORITE'] == 0) {
                    this.isFavorite = false;
                } else {
                    this.isFavorite = true;
                };

            } catch(e) {
                this.isFavorite = false;
            };

            // 이전 버전 존재 확인
            try {
                if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            }

            // SCMS 컨텐츠 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };

            SDLUtil.showLoadingBar(false);
            this.isLoading = false;

            Vue.$log.info('▶ KnowledgeVersionDetailPopup.vue detail =>', this.detail);
        });
    },
    mounted() {
        this.$nextTick(() => {
            /*
             * RecommendPopup.vue 로 이벤트 전달 -> (param : knowledgeId)
             * Footer 하단 markup 으로 인해 SKPMain.vue로 팝업을 위치, 이벤트를 전달 한다.
             * 
             * EventBus.$emit('knowledge-recommend-show', this.getKnowledgeId);
             */
        });
    },
    beforeDestroy() {
        Vue.$log.info('▶ KnowledgeVersionDetailPopup.vue beforeDestroy.');
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeVersionDetailPopup.vue